module.exports = __webpack_public_path__ + "static/media/dinero_marron.07d80f8c.png";